import './DownloadBar.scss';

import { ReactComponent as Document } from '../../images/icons/menu/Document.svg';
import { ReactComponent as Download } from '../../images/icons/Download.svg';

type Props = {
  subtitle: string;
  description: string;
  iconSubtitle: string;
  onClick: () => void;
};

const DownloadBar = ({ subtitle, description, iconSubtitle, onClick }: Props) => {
  return (
    <div className='download-bar-container'>
      <div className='icon document'>
        <Document />
        <p>{iconSubtitle}</p>
      </div>
      <div className='text'>
        <span>{subtitle}</span>
        <span>{description}</span>
      </div>
      <Download onClick={onClick} />
    </div>
  );
};

export default DownloadBar;
